import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Container, Spinner, Modal, Button } from "react-bootstrap";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";
import moment from "moment";
import Select from "react-select";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { useNetworkStatus } from "../hooks/useNetworkStatus";
import { renderPdfToImages } from "../utils/pdfPrint";
import { useSearchParams } from "react-router-dom";

const Homework = () => {
  const { userId, GetstudentData } = useContext(ProductContext);
  const authtoken = localStorage.getItem("token");
  const studentId = GetstudentData?.id;
  const [searchParams] = useSearchParams();
  const notifiableType = searchParams.get("notifiable_type");
  const notifiableId = searchParams.get("notifiable_id");

  const [homeworks, setHomeworks] = useState(() => {
    const clsSec = GetstudentData?.class_section_id || GetstudentData?.cls_sec?.id;
    return getCachedData(`homework_${clsSec}_${studentId}`) || [];
  });
  const [loading, setLoading] = useState(() => {
    const clsSec = GetstudentData?.class_section_id || GetstudentData?.cls_sec?.id;
    return !getCachedData(`homework_${clsSec}_${studentId}`);
  });
  const { showSlowMsg, message } = useNetworkStatus(loading, 4000);

  const [clsSecId, setClsSecId] = useState(null);

  const fetchStudentId = async () => {
    const cacheKey = `hw_student_${userId}`;
    const cached = getCachedData(cacheKey);
    if (cached) {
      setClsSecId(cached);

    }
    try {
      const response = await fetch(`https://api.mirai.healthcare/api/student?regs_id=${userId}`, {
        headers: { "x-auth": `${authtoken}` }
      });

      const data = await response.json();

      if (data.success && data.message.length > 0) {
        const studentData = data.message[0];
        setClsSecId(studentData.class_section_id);
        setCachedData(cacheKey, studentData.class_section_id);
      } else {
        console.error("Class Section ID not found in API response");
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  console.log(clsSecId, "clsSecId15")


  useEffect(() => {
    if (userId) {
      fetchStudentId();
    }
  }, [userId]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredHomeworks, setFilteredHomeworks] = useState([]);

  const fetchHomeworkData = async () => {
    if (!clsSecId) return;

    const cacheKey = `homework_${clsSecId}_${studentId}`;
    const cached = getCachedData(cacheKey);
    if (cached) {
      setHomeworks(cached);
      setLoading(false);
    }

    if (!cached) setLoading(true);
    try {
      const response = await axios.get(
        `https://api.mirai.healthcare/api/homework/homework/${clsSecId}?studentId=${studentId}`,
        { headers: { "x-auth": `${authtoken}` } }
      );

      if (response.data.length > 0) {
        const sortedData = response.data.sort(
          (a, b) => new Date(b.created_at || b.date) - new Date(a.created_at || a.date)
        );
        setHomeworks(sortedData);
        setCachedData(cacheKey, sortedData);
      }
    } catch (error) {
      console.error("Error fetching homework data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clsSecId) {
      fetchHomeworkData();
    }
  }, [clsSecId]); // Runs only when clsSecId is updated

  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [titleSearch, setTitleSearch] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [selectedSubject, setSelectedSubject] = useState("");
  const [subjects, setSubjects] = useState([]);

  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const [selectedFileTitle, setSelectedFileTitle] = useState("");
  const [zoomScale, setZoomScale] = useState(1);
  const [rotationDegrees, setRotationDegrees] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [fileLoading, setFileLoading] = useState(true);

  const handleOpenModal = (url, title) => {
    setSelectedFileUrl(url);
    setSelectedFileTitle(title);
    setZoomScale(1);
    setRotationDegrees(0);
    setFileLoading(true);
    setShowFileModal(true);
  };

  const printFile = async (url) => {
    if (!url || printing) return;

    if (window.ReactNativeWebView) {
      setPrinting(true);
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: "PRINT_FILE", url, filename: selectedFileTitle }));
      setTimeout(() => setPrinting(false), 1500);
      return;
    }

    setPrinting(true);

    const cleanUrl = url.split("?")[0].toLowerCase();
    const isPdf = cleanUrl.endsWith(".pdf");

    const oldIframe = document.getElementById("hwPrintIframe");
    if (oldIframe) oldIframe.remove();

    const iframe = document.createElement("iframe");
    iframe.id = "hwPrintIframe";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.style.zIndex = "-9999";
    document.body.appendChild(iframe);

    try {
      let imageHtml = "";
      if (isPdf) {
        try {
          const pageImages = await renderPdfToImages(url);
          imageHtml = pageImages.map(src => `<img src="${src}" class="pdfPrintPage" />`).join("");
        } catch (pdfErr) {
          console.warn("PDF render for print failed:", pdfErr);
          imageHtml = `<iframe src="${url}" style="width:100%;height:100vh;border:none;"></iframe>`;
        }
      } else {
        let printSrc = url;
        try {
          const res = await fetch(url);
          if (res.ok) {
            const blob = await res.blob();
            printSrc = window.URL.createObjectURL(blob);
          }
        } catch (e) {
          console.warn("Fetch blob failed for print image:", e);
        }
        imageHtml = `<img src="${printSrc}" class="pdfPrintPage" />`;
      }

      const docHtml = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>Print Homework</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style>
              body { margin: 0; padding: 0; background: #ffffff; text-align: center; }
              .pdfPrintPage { max-width: 100%; height: auto; display: block; margin: 0 auto 10px auto; page-break-after: always; }
              .pdfPrintPage:last-child { page-break-after: auto; }
              @media print {
                body { margin: 0; padding: 0; }
                .pdfPrintPage { max-width: 100%; width: 100%; height: auto; page-break-after: always; }
                .pdfPrintPage:last-child { page-break-after: auto; }
              }
            </style>
          </head>
          <body>
            ${imageHtml}
          </body>
        </html>
      `;

      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(docHtml);
      iframeDoc.close();

      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          console.error("Iframe print error:", e);
        }
        setPrinting(false);
        setTimeout(() => iframe.remove(), 2000);
      }, 500);
    } catch (err) {
      console.error("Print error:", err);
      iframe.remove();
      setPrinting(false);
    }
  };


  const downloadFile = async (url, filename) => {
    if (!url || downloading) return;
    setDownloading(true);
    try {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "DOWNLOAD_FILE", url, filename }));
        setTimeout(() => setDownloading(false), 1500);
        return;
      }

      const cleanUrl = url.split("?")[0].toLowerCase();
      let ext = ".jpg";
      if (cleanUrl.endsWith(".pdf")) ext = ".pdf";
      else if (cleanUrl.endsWith(".png")) ext = ".png";
      else if (cleanUrl.endsWith(".jpg") || cleanUrl.endsWith(".jpeg")) ext = ".jpg";
      else if (cleanUrl.endsWith(".gif")) ext = ".gif";
      else if (cleanUrl.endsWith(".webp")) ext = ".webp";
      else if (cleanUrl.endsWith(".docx")) ext = ".docx";
      else if (cleanUrl.endsWith(".xlsx")) ext = ".xlsx";

      const name = (filename || "homework-file").replace(/[^a-zA-Z0-9-_]/g, "_") + ext;

      // Method 1: Fetch as blob
      try {
        const response = await fetch(url);
        if (response.ok) {
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = name;
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          }, 1000);
          setDownloading(false);
          return;
        }
      } catch (fetchErr) {
        console.warn("Fetch blob download failed, trying canvas/direct download...", fetchErr);
      }

      // Method 2: Canvas DataURL download for images
      const isImage = [".png", ".jpg", ".jpeg", ".gif", ".webp"].some(e => cleanUrl.endsWith(e));
      if (isImage) {
        try {
          const dataUrl = await new Promise((resolve) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => {
              try {
                const canvas = document.createElement("canvas");
                canvas.width = img.naturalWidth || img.width;
                canvas.height = img.naturalHeight || img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL(ext === ".png" ? "image/png" : "image/jpeg", 0.95));
              } catch (e) { resolve(null); }
            };
            img.onerror = () => resolve(null);
            img.src = url;
          });

          if (dataUrl) {
            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            setTimeout(() => document.body.removeChild(link), 1000);
            setDownloading(false);
            return;
          }
        } catch (canvasErr) {
          console.warn("Canvas download failed", canvasErr);
        }
      }

      // Method 3: Direct link click
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 1000);

    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setDownloading(false);
    }
  };




  const getFileType = (url) => {
    if (!url) return "";
    try {
      const cleanUrl = url.split("?")[0].toLowerCase();
      if (cleanUrl.endsWith(".pdf")) return "pdf";

      // Known document formats that cannot be displayed in <img> or <iframe> easily
      const docExtensions = [".docx", ".doc", ".xlsx", ".xls", ".pptx", ".ppt", ".zip", ".rar", ".txt", ".csv"];
      if (docExtensions.some(ext => cleanUrl.endsWith(ext))) {
        return "other";
      }

      // Default to image for other files (photos/scans of homework)
      return "image";
    } catch (e) {
      console.error(e);
    }
    return "image";
  };

  const getSubjectCardStyle = (subject = "") => {
    const sub = subject.toLowerCase();
    if (sub.includes("math")) {
      return {
        stripeColor: "#818cf8", // Indigo
        bgColor: "#f5f3ff",
        textColor: "#6d28d9",
        iconText: "√x"
      };
    }
    if (sub.includes("english") || sub.includes("lang")) {
      return {
        stripeColor: "#34d399", // Emerald Green
        bgColor: "#ecfdf5",
        textColor: "#047857",
        iconText: "ENG"
      };
    }
    if (sub.includes("science") || sub.includes("evs") || sub.includes("bio") || sub.includes("chem")) {
      return {
        stripeColor: "#60a5fa", // Blue
        bgColor: "#eff6ff",
        textColor: "#1d4ed8",
        iconClass: "ti ti-flask" // Beaker icon
      };
    }
    if (sub.includes("social") || sub.includes("hist") || sub.includes("geo") || sub.includes("stud")) {
      return {
        stripeColor: "#fb923c", // Orange
        bgColor: "#fff7ed",
        textColor: "#c2410c",
        iconClass: "ti ti-world" // Globe icon
      };
    }
    if (sub.includes("physic")) {
      return {
        stripeColor: "#a78bfa", // Purple/violet
        bgColor: "#faf5ff",
        textColor: "#7c3aed",
        iconClass: "ti ti-book" // Book/notebook icon
      };
    }
    // Fallback/Default
    return {
      stripeColor: "#cbd5e1", // Grey slate
      bgColor: "#f8fafc",
      textColor: "#475569",
      iconClass: "ti ti-notebook" // Generic notebook icon
    };
  };

  const subjectOptions = [
    { value: "", label: "All Subjects" },
    ...subjects.map((sub) => ({
      value: sub,
      label: sub,
    })),
  ];

  const handleApplyFilter = () => {
    let filtered = [...homeworks];

    if (fromDate) {
      filtered = filtered.filter((item) =>
        moment(item.date).isSameOrAfter(moment(fromDate), "day")
      );
    }

    if (toDate) {
      filtered = filtered.filter((item) =>
        moment(item.date).isSameOrBefore(moment(toDate), "day")
      );
    }

    setFilteredHomeworks(filtered);
    setIsFilterApplied(true); // ✅ important
  };

  const applyFilters = () => {
    let filtered = [...homeworks];

    // ✅ Title filter
    if (titleSearch) {
      filtered = filtered.filter((item) =>
        item.title && item.title.toLowerCase().includes(titleSearch.toLowerCase())
      );
    }

    // ✅ Subject filter
    if (selectedSubject) {
      filtered = filtered.filter(
        (item) => item.subject_name === selectedSubject
      );
    }

    // ✅ From date
    if (fromDate) {
      filtered = filtered.filter((item) =>
        moment(item.created_at || item.date).isSameOrAfter(moment(fromDate), "day")
      );
    }

    // ✅ To date
    if (toDate) {
      filtered = filtered.filter((item) =>
        moment(item.created_at || item.date).isSameOrBefore(moment(toDate), "day")
      );
    }

    setFilteredHomeworks(filtered);
  };


  useEffect(() => {
    applyFilters();
    setCurrentPage(1);
  }, [selectedSubject, titleSearch, fromDate, toDate, homeworks]);


  const handleResetFilter = () => {
    setSelectedSubject("");
    setTitleSearch("");
    setFromDate("");
    setToDate("");
  };

  // const displayData = filteredHomeworks.length > 0 ? filteredHomeworks : homeworks;
  // const displayData = isFilterApplied ? filteredHomeworks : homeworks;

  const displayData = filteredHomeworks;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = displayData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(displayData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  useEffect(() => {
    if (homeworks.length > 0) {
      const uniqueSubjects = [
        ...new Set(homeworks.map((item) => item.subject_name))
      ];
      setSubjects(uniqueSubjects);
    }
  }, [homeworks]);



  return (
    <div className="page-wrapper text-start" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <style>{`
        .banner-container {
          background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
          border-radius: 16px;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);
          min-height: 140px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          overflow: hidden;
          padding: 0;
        }
        .banner-text-section {
          padding: 24px;
          z-index: 2;
          max-width: 60%;
        }
        .banner-image-block {
          height: 140px;
          width: 160px;
          background: #ffffff;
          border-top-left-radius: 35px;
          border-bottom-left-radius: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          z-index: 2;
        }
        @media (max-width: 575.98px) {
          .banner-container {
            min-height: 110px;
          }
          .banner-text-section {
            padding: 16px;
            max-width: 60%;
          }
          .banner-image-block {
            width: 110px;
            height: 110px;
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
          .pagination .page-link {
            width: 28px !important;
            height: 28px !important;
            font-size: 11px !important;
          }
        }
        @media (max-width: 767.98px) {
          .homework-list-container {
            position: relative;
            padding-left: 40px !important;
          }
          .homework-list-container::before {
            content: "";
            position: absolute;
            left: 20px;
            top: 10px;
            bottom: 10px;
            width: 3px;
            background: linear-gradient(to bottom, #3b82f6, #60a5fa);
            border-radius: 2px;
          }
          .homework-timeline-item {
            position: relative;
          }
          .homework-timeline-dot {
            position: absolute;
            left: -36px;
            top: 15px;
            width: 32px;
            height: 32px;
            background-color: #3b82f6;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
            border: 4px solid #ffffff;
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
          }
          .homework-timeline-dot i {
            color: #ffffff;
            font-size: 12px;
          }
        }
        @media (min-width: 768px) {
          .homework-timeline-dot {
            display: none;
          }
        }
      `}</style>
      <Header />
      <Container className="py-4" style={{ maxWidth: '1000px', paddingBottom: '100px' }}>
        {/* Banner Section */}
        <div className="banner-container mb-4">
          <div className="banner-text-section">
            <span className="text-secondary fw-semibold fs-13 d-block mb-1">Stay on top of your</span>
            <h2 className="fw-bold mb-1" style={{ color: "#4f46e5", fontSize: "26px" }}>Homework!</h2>
            <span className="text-muted fs-13 d-block">Keep learning, keep growing ✨</span>
          </div>

          {/* Studying boy illustration block */}
          <div className="banner-image-block">
            <img
              src="/assets/img/boy-study.png"
              alt="Studying Boy"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
            />
          </div>
          {/* Subtle gradient shapes for extra premium feel */}
          <div
            style={{
              position: "absolute",
              width: "120px",
              height: "120px",
              background: "rgba(255,255,255,0.4)",
              borderRadius: "50%",
              top: "-40px",
              right: "-20px",
              filter: "blur(20px)",
              zIndex: 1
            }}
          />
        </div>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            {showSlowMsg && (
              <div className="text-center text-muted small mt-3 px-3">
                ⚠️ {message}
              </div>
            )}
          </div>
        ) : (
          <>
            {/* Search & Filter Row */}
            <div className="mb-4">
              <div className="d-flex align-items-center gap-2">
                <div className="input-group border shadow-none" style={{ borderRadius: '10px', overflow: 'hidden', background: '#ffffff' }}>
                  <span className="input-group-text bg-transparent border-0 text-muted pe-1">
                    <i className="ti ti-search fs-18" />
                  </span>
                  <input
                    type="text"
                    className="form-control bg-transparent border-0 fs-14 py-2 ps-1 text-dark"
                    placeholder="Search homework..."
                    value={titleSearch}
                    onChange={(e) => setTitleSearch(e.target.value)}
                    style={{ boxShadow: 'none' }}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-outline-light border d-flex align-items-center justify-content-center"
                  onClick={() => setShowFilters(!showFilters)}
                  style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '10px',
                    borderColor: '#e2e8f0',
                    backgroundColor: showFilters ? '#e2e8f0' : 'white',
                    color: '#475569'
                  }}
                  title="Toggle Filters"
                >
                  <i className="ti ti-adjustments-horizontal fs-18" />
                </button>
              </div>

              {/* Collapsible Filter Dropdown/Panel */}
              {showFilters && (
                <div className="card border-0 shadow-sm mt-3 p-3 text-start" style={{ borderRadius: '12px', background: '#ffffff', border: '1px solid #e2e8f0' }}>
                  <div className="row g-3 align-items-end">
                    <div className="col-12 col-md-3">
                      <label className="form-label text-secondary fw-semibold fs-12 mb-1">Subject</label>
                      <Select
                        options={subjectOptions}
                        value={subjectOptions.find(opt => opt.value === selectedSubject)}
                        onChange={(selected) => setSelectedSubject(selected?.value || "")}
                        isClearable
                        placeholder="Select Subject"
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <label className="form-label text-secondary fw-semibold fs-12 mb-1">From Date</label>
                      <input
                        type="date"
                        className="form-control fs-13"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        style={{ height: '38px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <label className="form-label text-secondary fw-semibold fs-12 mb-1">To Date</label>
                      <input
                        type="date"
                        className="form-control fs-13"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        style={{ height: '38px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                      />
                    </div>
                    <div className="col-12 col-md-3 d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm flex-grow-1"
                        onClick={applyFilters}
                        style={{ height: '38px', borderRadius: '6px' }}
                      >
                        Apply
                      </button>
                      <button
                        type="button"
                        className="btn btn-light btn-sm flex-grow-1"
                        onClick={handleResetFilter}
                        style={{ height: '38px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>



            {/* Homework List Section */}
            <div className="row g-3 text-start homework-list-container">
              {currentItems.length > 0 ? (
  currentItems.map((homework) => {
    const styleMeta = getSubjectCardStyle(homework.subject_name);

    // Dynamic Highlight Condition (apne state variable ke anusar adjust kar lein, e.g., selectedId)
    const isHighlighted = Number(notifiableId) === Number(homework?.id);

    // Calculate status
    let statusLabel = "";
    let statusBadgeStyle = {};

    if (homework.status === "Completed" || homework.is_submitted) {
      statusLabel = "Completed";
      statusBadgeStyle = { backgroundColor: '#e0fdf4', color: '#166534', border: '1px solid #bbf7d0' };
    } else {
      statusLabel = "Assigned";
      statusBadgeStyle = { backgroundColor: '#e0f2fe', color: '#0369a1', border: '1px solid #bae6fd' };
    }

    const isCustom = homework.custom_students && homework.custom_students.length > 0;
    const targetLabel = isCustom ? "Custom home work" : "Class wise home work";
    const targetBadgeStyle = isCustom
      ? { backgroundColor: '#fff7ed', color: '#c2410c', border: '1px solid #fed7aa', borderRadius: '4px', padding: '2px 6px', fontSize: '10px', fontWeight: '600' }
      : { backgroundColor: '#f5f3ff', color: '#5b21b6', border: '1px solid #ddd6fe', borderRadius: '4px', padding: '2px 6px', fontSize: '10px', fontWeight: '600' };

    return (
      <div className="col-12 col-md-6 d-flex align-items-stretch homework-timeline-item" key={homework.id}>
        <div className="homework-timeline-dot">
          <i className="ti ti-book"></i>
        </div>
        <div
          className="p-3 d-flex flex-column justify-content-between w-100"
          style={{
            borderRadius: '16px',
            borderLeft: `6px solid ${isHighlighted ? '#6366f1' : styleMeta.stripeColor}`, // Highlight par Left border Indigo
            borderTop: isHighlighted ? '2px solid #6366f1' : '1px solid #f1f5f9',
            borderRight: isHighlighted ? '2px solid #6366f1' : '1px solid #f1f5f9',
            borderBottom: isHighlighted ? '2px solid #6366f1' : '1px solid #f1f5f9',
            background: isHighlighted 
              ? 'linear-gradient(145deg, #eef2ff, #e0e7ff)' // Highlighted Soft Indigo Gradient
              : '#ffffff',
            boxShadow: isHighlighted 
              ? '0 0 18px rgba(99, 102, 241, 0.35)' // Glowing Indigo Shadow
              : '0 1px 3px 0 rgba(0,0,0,0.02)',
            transform: isHighlighted ? 'translateY(-2px)' : 'none',
            transition: 'all 0.3s ease-in-out',
          }}
          onMouseEnter={(e) => { 
            if (!isHighlighted) e.currentTarget.style.transform = 'translateY(-2px)' 
          }}
          onMouseLeave={(e) => { 
            if (!isHighlighted) e.currentTarget.style.transform = 'none' 
          }}
        >
          {/* Upper Section: Icon & Info */}
          <div className="d-flex align-items-start gap-3 text-start w-100 mb-2">
            {/* Subject Icon Container */}
            <div
              className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              style={{
                width: '42px',
                height: '42px',
                backgroundColor: styleMeta.bgColor,
                color: styleMeta.textColor,
                fontWeight: '700',
                fontSize: '12px'
              }}
            >
              {styleMeta.iconText ? (
                styleMeta.iconText
              ) : (
                <i className={`${styleMeta.iconClass} fs-16`} />
              )}
            </div>

            {/* Description Details */}
            <div className="flex-grow-1 text-start">
              <h5 className="fw-bold text-dark mb-1" style={{ fontSize: '15px' }}>{homework.title}</h5>
              <span className="fw-semibold d-block mb-1" style={{ color: styleMeta.textColor, fontSize: '13px' }}>
                {homework.subject_name}
              </span>
              <p className="text-muted fs-12 mb-0 line-clamp-2" style={{ maxWidth: '100%', lineHeight: '1.4', minHeight: '34px' }}>
                {homework.description}
              </p>
            </div>
          </div>

          {/* Attachment Box if File Exists */}
          {homework.files && homework.files.length > 0 && (
            <div
              className="d-flex align-items-center justify-content-between gap-2 my-2 p-2 rounded"
              style={{ backgroundColor: isHighlighted ? '#ffffff80' : '#f8fafc', border: '1px solid #e2e8f0' }}
            >
              <span className="d-inline-flex align-items-center gap-1 text-secondary fs-12 fw-medium">
                <i className="ti ti-paperclip text-primary fs-14" />
                Attachment
              </span>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenModal(homework.files[0].file_url, homework.title);
                }}
                className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1 fs-12 py-1 px-2.5"
                style={{ borderRadius: '6px', fontWeight: '500' }}
              >
                <i className="ti ti-eye fs-14" /> View Homework
              </button>
            </div>
          )}

          {/* Lower Section: Meta, Due, & Action */}
          <div className="pt-2 border-top w-100" style={{ borderColor: isHighlighted ? '#c7d2fe' : '#f8fafc' }}>
            {/* Meta Row: Assigned / Date */}
            <div className="d-flex align-items-center justify-content-between text-secondary" style={{ fontSize: '11px' }}>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <i className="ti ti-users fs-12 text-muted" />
                <span className="badge" style={targetBadgeStyle}>{targetLabel}</span>
                <span className="badge px-2 py-1 fs-10 fw-semibold" style={{ ...statusBadgeStyle, borderRadius: '4px' }}>
                  {statusLabel === "Completed" && <i className="ti ti-check me-1" />}
                  {statusLabel}
                </span>
                <span className="d-inline-flex align-items-center gap-1 ms-1">
                  <i className="ti ti-calendar-event fs-12 text-muted" />
                  Created At: {homework.created_at ? moment.utc(homework.created_at).utcOffset("+05:30").format("DD MMM YYYY, hh:mm A") : moment.utc(homework.date).utcOffset("+05:30").format("DD MMM YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  })
) : (
  <div className="text-center py-5 w-100 card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
    <i className="ti ti-notebook-off text-muted fs-40 mb-2" />
    <p className="text-muted mb-0">No homework available.</p>
  </div>
)}
            </div>

            {/* Pagination footer */}
            {displayData.length > 0 && (
              <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3 mt-4 pt-3 mb-4 pb-4 border-top w-100" style={{ marginBottom: '60px' }}>
                <div className="text-secondary fs-12 text-center text-sm-start">
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, displayData.length)} of {displayData.length} entries
                </div>

                <div className="d-flex flex-wrap align-items-center justify-content-center gap-2 max-w-100 overflow-x-auto">
                  <nav aria-label="Page navigation" className="mb-0">
                    <ul className="pagination pagination-sm mb-0" style={{ gap: '4px', flexWrap: 'wrap', justifyContent: 'center' }}>
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          type="button"
                          className="page-link border-0 rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: '32px', height: '32px', backgroundColor: '#f1f5f9', color: '#64748b' }}
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage - 1);
                          }}
                        >
                          <i className="ti ti-chevron-left fs-12" />
                        </button>
                      </li>
                      {getPageNumbers().map((page) => (
                        <li
                          key={page}
                          className={`page-item ${currentPage === page ? "active" : ""}`}
                        >
                          <button
                            type="button"
                            className="page-link border-0 rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              width: '32px',
                              height: '32px',
                              backgroundColor: currentPage === page ? '#4f46e5' : '#f1f5f9',
                              color: currentPage === page ? '#ffffff' : '#64748b',
                              fontWeight: '600'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(page);
                            }}
                          >
                            {page}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? "disabled" : ""}`}>
                        <button
                          type="button"
                          className="page-link border-0 rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: '32px', height: '32px', backgroundColor: '#f1f5f9', color: '#64748b' }}
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage + 1);
                          }}
                        >
                          <i className="ti ti-chevron-right fs-12" />
                        </button>
                      </li>
                    </ul>
                  </nav>

                  {/* Items Per Page Select */}
                  <select
                    className="form-select form-select-sm border-light ms-sm-2"
                    value={itemsPerPage}
                    onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    style={{ width: '110px', height: '32px', fontSize: '12px', borderRadius: '6px' }}
                  >
                    <option value={5}>5 / page</option>
                    <option value={10}>10 / page</option>
                    <option value={20}>20 / page</option>
                    <option value={50}>50 / page</option>
                  </select>
                </div>
              </div>
            )}
          </>
        )}

        {/* Homework File Preview Modal */}
        <Modal
          show={showFileModal}
          onHide={() => setShowFileModal(false)}
          size="lg"
          centered
          className="homework-file-modal"
        >
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="fw-bold fs-16 text-dark">
              {selectedFileTitle || "Homework Document"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3">
            {getFileType(selectedFileUrl) === "image" && (
              <div className="d-flex justify-content-center gap-2 mb-3 bg-light p-2 rounded border border-light">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setZoomScale(prev => Math.max(0.2, prev - 0.1))}
                  title="Zoom Out"
                  className="d-flex align-items-center justify-content-center"
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                >
                  <i className="ti ti-zoom-out fs-14" />
                </Button>
                <span className="d-flex align-items-center justify-content-center fw-semibold text-secondary px-2" style={{ fontSize: "13px", minWidth: "55px" }}>
                  {Math.round(zoomScale * 100)}%
                </span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setZoomScale(prev => Math.min(3, prev + 0.1))}
                  title="Zoom In"
                  className="d-flex align-items-center justify-content-center"
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                >
                  <i className="ti ti-zoom-in fs-14" />
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setZoomScale(1)}
                  title="Reset Zoom"
                  className="d-flex align-items-center justify-content-center ms-2"
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                >
                  <i className="ti ti-refresh fs-14" />
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setRotationDegrees(prev => (prev + 90) % 360)}
                  title="Rotate"
                  className="d-flex align-items-center justify-content-center ms-1"
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                >
                  <i className="ti ti-rotate-clockwise fs-14" />
                </Button>
              </div>
            )}
            <div
              className="d-flex align-items-center justify-content-center bg-light rounded position-relative"
              style={{
                minHeight: "450px",
                height: "60vh",
                overflow: "auto",
                border: "1px dashed #cbd5e1"
              }}
            >
              {fileLoading && (
                <div className="position-absolute top-50 start-50 translate-middle text-center" style={{ zIndex: 15 }}>
                  <Spinner animation="border" variant="primary" />
                  <p className="text-muted small mt-2 mb-0 fw-medium">Loading document...</p>
                </div>
              )}
              {getFileType(selectedFileUrl) === "pdf" ? (
                <div className="position-relative w-100 h-100 overflow-hidden">
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "48px",
                      height: "48px",
                      backgroundColor: "#ffffff",
                      zIndex: 10,
                      pointerEvents: "auto"
                    }}
                  />
                  <iframe
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedFileUrl)}&embedded=true`}
                    className="w-100 h-100 rounded"
                    style={{ border: "none" }}
                    title="Homework PDF Preview"
                    onLoad={() => setFileLoading(false)}
                  />
                </div>
              ) : getFileType(selectedFileUrl) === "image" ? (


                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    minWidth: "100%",
                    minHeight: "100%",
                    padding: "20px",
                    overflow: "auto"
                  }}
                >
                  <img
                    src={selectedFileUrl}
                    alt="Homework Preview"
                    className="img-fluid rounded"
                    onLoad={() => setFileLoading(false)}
                    onError={() => setFileLoading(false)}
                    style={{
                      maxHeight: "100%",
                      transform: `scale(${zoomScale}) rotate(${rotationDegrees}deg)`,
                      transformOrigin: "center center",
                      transition: "transform 0.2s ease-in-out",
                      objectFit: "contain"
                    }}
                  />
                </div>
              ) : (
                <div className="text-center p-4">
                  <i className="ti ti-file-text text-muted mb-3" style={{ fontSize: "64px" }} />
                  <p className="text-secondary fw-medium mb-1">Preview not available for this file type</p>
                  <p className="text-muted small mb-0">Please download the file using the button below to view it.</p>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            <Button
              variant="light"
              onClick={() => setShowFileModal(false)}
              style={{ borderRadius: "8px", fontWeight: "600" }}
            >
              Close
            </Button>
            {getFileType(selectedFileUrl) === "pdf" ? (
              <Button
                variant="primary"
                disabled={downloading}
                onClick={() => downloadFile(selectedFileUrl, selectedFileTitle)}
                className="d-flex align-items-center gap-2 px-4"
                style={{ borderRadius: "8px", fontWeight: "600" }}
              >
                {downloading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" /> Downloading...
                  </>
                ) : (
                  <>
                    <i className="ti ti-download" /> Download File
                  </>
                )}
              </Button>
            ) : (
              <Button
                variant="primary"
                disabled={printing}
                onClick={() => printFile(selectedFileUrl)}
                className="d-flex align-items-center gap-2 px-4"
                style={{ borderRadius: "8px", fontWeight: "600" }}
              >
                {printing ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" /> Preparing...
                  </>
                ) : (
                  <>
                    <i className="ti ti-printer" /> Print
                  </>
                )}
              </Button>
            )}
          </Modal.Footer>


        </Modal>
      </Container>
    </div>
  );
};

export default Homework;
